export const FLASHCARD_TYPE_LABELS = {
  method_choice: "Pick the method",
  trigger_cloze: "Pattern cue",
  common_trap: "Common trap",
  basic: "Recall",
};

export const getFlashcardTypeLabel = (type) =>
  FLASHCARD_TYPE_LABELS[type] || "";
